import React from 'react'
import { useEffect } from 'react'
import LayoutMicro from '../../components/layout_micro'
import Container from '../../components/layout_micro/container'
import ResponsiveFonts from '../../components/layout_micro/responsiveFonts'
import Cover from './cover'
import Footer from './footer'
import Services from './services'
import Steps from './steps'

const Landing = props => {

  useEffect(() => {
    window.scrollTo(0, 0)
  });

  return (
    <LayoutMicro>
      <ResponsiveFonts>
        <Cover />
      </ResponsiveFonts>
      <Container page>
        <ResponsiveFonts>
          <Services />
        </ResponsiveFonts>
      </Container>
      <ResponsiveFonts>
        <Steps />
        <Container>
          <Footer />
        </Container>
      </ResponsiveFonts>
    </LayoutMicro>
  )
}

export default Landing
